/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_View_ListInputs */

const en_dashboard_view_list = /** @type {(inputs: Dashboard_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List`)
};

const pt_br2_dashboard_view_list = /** @type {(inputs: Dashboard_View_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista`)
};

/**
* | output |
* | --- |
* | "List" |
*
* @param {Dashboard_View_ListInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_view_list = /** @type {((inputs?: Dashboard_View_ListInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_View_ListInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_view_list(inputs)
	return pt_br2_dashboard_view_list(inputs)
});